import type { ReactNode } from 'react'

import { PostHogProvider } from 'posthog-js/react'

import { posthogInstance } from './config'

interface PostHogAppProviderProps {
  children: ReactNode
}

export const PostHogAppProvider = ({
  children,
}: PostHogAppProviderProps): ReactNode => {
  return <PostHogProvider client={posthogInstance}>{children}</PostHogProvider>
}
